/**
 * Search params của màn danh sách sản phẩm.
 *
 * Filter trạng thái mặc định là "đang hoạt động": vào `/products` là thấy ngay
 * hàng đang bán, không phải lọc tay. Vì vậy `active` bỏ trống KHÔNG còn nghĩa là
 * "tất cả" — muốn xem toàn bộ phải chọn tường minh `active=all`.
 */

export type ProductActiveFilter = 'all' | 'active' | 'inactive'

export const DEFAULT_PRODUCT_ACTIVE_FILTER: ProductActiveFilter = 'active'

export interface ProductsSearch {
    q?: string
    active?: ProductActiveFilter
    sellable?: 'sellable' | 'internal'
    page?: number
}

const ACTIVE_FILTERS: ReadonlyArray<ProductActiveFilter> = [
    'all',
    'active',
    'inactive',
]

function isActiveFilter(value: unknown): value is ProductActiveFilter {
    return ACTIVE_FILTERS.includes(value as ProductActiveFilter)
}

/** Chuẩn hoá query string thành search params hợp lệ, bỏ mọi giá trị lạ. */
export function parseProductsSearch(
    search: Record<string, unknown>,
): ProductsSearch {
    const out: ProductsSearch = {}
    if (typeof search.q === 'string' && search.q) out.q = search.q
    if (isActiveFilter(search.active)) out.active = search.active
    if (search.sellable === 'sellable' || search.sellable === 'internal') {
        out.sellable = search.sellable
    }
    const page =
        typeof search.page === 'number' ? search.page : Number(search.page)
    if (Number.isFinite(page) && page > 1) out.page = page
    return out
}

/** URL chưa chọn filter → mặc định chỉ hiện sản phẩm đang hoạt động. */
export function resolveProductActiveFilter(
    active: ProductActiveFilter | undefined,
): ProductActiveFilter {
    return active ?? DEFAULT_PRODUCT_ACTIVE_FILTER
}

/** `undefined` = không lọc theo trạng thái. */
export function toIsActiveParam(
    filter: ProductActiveFilter,
): boolean | undefined {
    if (filter === 'all') return undefined
    return filter === 'active'
}
